import React from "react";
import Sidebar from "@/components/Sidebar";
import StatusBar from "@/components/StatusBar";
import InstallPWA from "@/components/InstallPWA";
import { Toaster } from "sonner";
import { useSidebarMode, sidebarWidthClass } from "@/lib/sidebarMode";

export default function Layout({ children }) {
  const { mode, isMobile } = useSidebarMode();
  return (
    <div className="min-h-screen bg-[#0a0f1a] text-slate-100">
      <Sidebar />
      <StatusBar sidebarMode={mode} isMobile={isMobile} />
      <main
        className={`${sidebarWidthClass(mode, isMobile)} main-safe p-3 sm:p-6 transition-[margin] duration-150 overflow-x-hidden`}
        data-testid="main-content"
      >
        {children}
      </main>
      <InstallPWA />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#131c2d",
            border: "1px solid #1e293b",
            color: "#f8fafc",
          },
        }}
      />
    </div>
  );
}
